import React from "react";
import PropertyNetRevenueTable from "./PropertyNetRevenueTable";

const PropertyNetRevenueList = () => {
  return (
    <div className="row m-0">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Property Net Revenue</h4>
            <p className="card-subtitle mb-4">
              Net booking revenue for the selected date range and property.
            </p>
            <PropertyNetRevenueTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyNetRevenueList;
